import { render } from "./block_enlace_simple.vue?vue&type=template&id=6c471849"
import script from "./block_enlace_simple.vue?vue&type=script&lang=js"
export * from "./block_enlace_simple.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__